export const basisOfDesignOptions = [
  "",
  "Aaon",
  "Alliance Air",
  "Annexair",
  "ClimateCraft",
  "Daikin",
  "Dectron",
  "DesertAire",
  "Engineered Air",
  "Governair",
  "Haakon",
  "Huntair",
  "Ingenia",
  "Innovent",
  "Mammoth",
  "Nortek - Unspecified Brand",
  "Other",
  "Petra",
  "Poolpak",
  "Scott Springfield",
  "SeasonsFour",
  "Seresco",
  "Temtrol",
  "Trane",
  "Venmar",
  "Ventrol",
  "XeteX",
  "Xnergy",
  "York Custom",
];

export function normalizeBasisOfDesign(value: unknown): string {
  return typeof value === "string" && basisOfDesignOptions.includes(value) ? value : "";
}

export function hasInvalidBasisOfDesign(value: unknown): boolean {
  return typeof value === "string" && value.trim() !== "" && normalizeBasisOfDesign(value) === "";
}
